class Currency {
    _listCurrency = [
        {
            text: 'UAH',
            value: 'UAH',
            translateRU: 'грн'
        },
        {
            text: 'USD',
            value: 'USD',
            translateRU: 'доллар'
        },
        {
            text: 'EUR',
            value: 'EUR',
            translateRU: 'евро'
        },
    ];

    get listCurrency() {
        return this._listCurrency;
    }

    findByValue(value) {
        return this._listCurrency.filter(item => item.value === value).shift();
    }
}

export const currency = new Currency();